/**
 * 3位/千分位加逗号
 * @param {number} 原数
 * @returns {number} rem大小
 */

function reverseStr(str: string) {
  return str.split('').reverse().join('')
}
function replace3Int(str: string) {
  return str.replace(/(\d{3})(?=\d)/g, '$1,')
}

export const currency = (intStr: string | number) => {
  const [integerPart, decimalPart] = String(intStr).split('.')
  // 仅格式化整数部分，避免小数部分插入千分位逗号后无法正常参与计算
  const formattedInteger = reverseStr(replace3Int(reverseStr(integerPart)))

  return decimalPart === undefined ? formattedInteger : `${formattedInteger}.${decimalPart}`
}
